import React from 'react';
import './betaLandingPage.css';
import col1Img from './col-1-img.png';
import BetaTermsOverlay from '../BetaTermsOverlay/betaTermsOverlay';
import { IntercomAPI } from 'react-intercom';

class BetaLandingPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showOverlay: false,
    };
  }

  toggleOverlay(e) {
    e.preventDefault();
    this.setState({
      showOverlay: !this.state.showOverlay,
    });
  }

  componentWillMount() {
    IntercomAPI('trackEvent', 'Email Studio - Landing Page Impression');
  }

  render() {
    return (
      <div className="landing-wrapper">
        {this.state.showOverlay && <BetaTermsOverlay toggleOverlay={e => this.toggleOverlay(e)} />}
        <div className="landing-container">
          <div className="landing-col-1">
            <div className="landing-col-1-img" />
          </div>
          <div className="landing-col-2">
            <h1>Email Studio</h1>
            <section>
              <h2>
                Enrich Each <span className="highlight">Email</span>
              </h2>
              <p>
                Incorporate UGC into email campaigns to drive engagement, sales, transaction value, and customer
                loyalty.
              </p>
            </section>
            <section>
              <h2>
                Bring your brand to <span className="highlight">life</span>
              </h2>
              <p>
                Drive traffic to product or property pages and increase the likelihood of conversion from site visitors
                by showcasing fresh and relevant UGC in trigger and promotional emails.
              </p>
            </section>
            <section>
              <h2>
                <span className="highlight">Build</span> a community
              </h2>
              <p>
                Encourage happy customers to take an active part in your brand post purchase or booking and become
                advocates.
              </p>
            </section>
            <section>
              <p>
                You understand that by clicking on the "I accept & continue" button below, you are agreeing to the{' '}
                <a className="terms-and-conditions-link" href="#terms" onClick={e => this.toggleOverlay(e)}>
                  beta program terms
                </a>
                .
              </p>
              <button onClick={this.props.setOptIn}>I accept & continue</button>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default BetaLandingPage;



// WEBPACK FOOTER //
// ./src/components/BetaLandingPage/betaLandingPage.js